import { Application } from '@hotwired/stimulus';

const EezyStimulusApplicationStart = Application.start();

const EezyStimulusApplication = {
  loadedControllers: [],
  register(identifier, controller) {
    // if a controller was already registered, do not re-register.
    if (this.loadedControllers.includes(identifier)) return;

    EezyStimulusApplicationStart.register(identifier, controller);
    // keep directory of registered controllers.
    this.loadedControllers.push(identifier);
  },
};

window.EezyStimulusApplication = EezyStimulusApplication;
